import {BreadcrumbsComponent} from "../../../components/UI/breadcrumb/BreadcrumbComponent";
import React, {useEffect, useState} from "react";
import Box from "@mui/material/Box";
import SettingsSignJobTable from "../../../components/UI/table/settings/SettingsSignJobTable";
import {useParams} from "react-router-dom";
import {constantsErrorMessages} from "../../../Constants";
import CircularProgress from "@mui/material/CircularProgress";
import ModalAlert from "../../../components/UI/table/customer-detales/ModalAlert";
import SignJobService from "../../../API/orders/job/SignJobService";
import UtilityService from "../../../API/common/UtilityService";
import SignJobNameService from "../../../API/orders/job/SignJobNameService";
import MaterialCloudUnits from "../../../API/material-cloud/common/MaterialCloudUnits";
import {modelParameterUnit} from "../../../data/ModelParameterUnit";
import {signJobType} from "../../../data/SignJobType";

const SettingsSignJob = () => {
    const profile = JSON.parse(localStorage.getItem("profile"))
    const {baseCurAbbreviation: baseCurrency, alternativeCurAbbreviation: alternativeCurrency} = profile
    const params = useParams();
    const {id} = params

    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [alertData, setAlertData] = useState({});

    const [currencies, setCurrencies] = useState([])
    const [jobNames, setJobNames] = useState([])
    const [units, setUnits] = useState([])

    const allParameterUnit = Object.entries(modelParameterUnit)
    const allSignJobType = Object.entries(signJobType)

    const handleModalAlert = (message, type = "error") => {
        setAlertData({
            type: type,
            open: true,
            message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
        })
    }
    const handleCloseAlert = () => {
        setAlertData((alert) => {
            return {...alert, open: false}
        })
    }

    useEffect(() => {
        setIsLoading(true)
        Promise.allSettled([SignJobService.get(id), UtilityService.getCurrencies(), SignJobNameService.getAllOrganization(), MaterialCloudUnits.get()])
            .then((results) => {
                setData(results[0]?.value?.data);
                setCurrencies(results[1]?.value?.data);
                setJobNames(results[2]?.value?.data);
                setUnits(results[3]?.value?.data)
            })
            .catch(function (error) {
                    handleModalAlert(error);
                }
            )
            .finally(() => setIsLoading(false))
    }, []);

    return isLoading ?
        <Box sx={{
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        }}>
            <CircularProgress disableShrink/>
        </Box> :
        <Box>
            <ModalAlert data={alertData} onClose={handleCloseAlert}/>
            <Box sx={{padding: "0 30px"}}>
                <BreadcrumbsComponent
                    page={"Затраты по работам"}
                    path={[{name: "Главная", href: "/"}, {name: "Настройки", href: "/settings"}]}/>
                <SettingsSignJobTable
                    data={data}
                    setData={setData}
                    baseCurrency={baseCurrency}
                    alternativeCurrency={alternativeCurrency}
                    id={id}
                    dataForSelects={{
                        currencies: currencies,
                        jobNames: jobNames,
                        allParameterUnit: allParameterUnit,
                        allSignJobType: allSignJobType,
                        units: units
                    }}
                    handleModalAlert={handleModalAlert}/>
            </Box>
        </Box>

}
export default SettingsSignJob